/* src/app/shared/common-ui/lib/scroll-viewer/scroll-viewer.component.less */
:host {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
:host .wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
:host .wrapper.indicator {
  -webkit-mask-image:
    linear-gradient(
      to bottom,
      transparent 0%,
      black 10%,
      black 90%,
      transparent 100%);
}
:host .wrapper.indicator.none {
  -webkit-mask-image: inherit;
}
:host .wrapper.indicator.top {
  -webkit-mask-image:
    linear-gradient(
      to bottom,
      black 90%,
      transparent 100%);
}
:host .wrapper.indicator.bottom {
  -webkit-mask-image:
    linear-gradient(
      to bottom,
      transparent 0%,
      black 10%);
}
:host .wrapper .scroll {
  flex: 1;
  display: flex;
  flex-direction: column;
}
:host .wrapper .scroll.mouseDown {
  -webkit-user-select: none;
  user-select: none;
}
:host .wrapper .scroll.overflow-auto {
  overflow: auto;
}
:host .wrapper .scroll.overflow-x {
  overflow-x: overlay;
  overflow-y: hidden;
}
:host .wrapper .scroll.overflow-y {
  overflow-x: hidden;
  overflow-y: auto;
  overflow-y: overlay;
}
/*# sourceMappingURL=scroll-viewer.component.css.map */
